import React from 'react'

import { Form, Col } from '_zari/core'

import { Select2CuentaContable } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

const CuentaContableEurosFormGroup = ({ iValue, iError, iTouched, setFieldValue }) => {
  const onChange = React.useCallback(
    salida => {
      setFieldValue('cuentaContableEuros', salida.value)
      setFieldValue('cuentaContableEurosInfo', salida.label)
    },
    [setFieldValue]
  )

  const clickClear = React.useCallback(() => {
    setFieldValue('cuentaContableEuros', '')
    setFieldValue('cuentaContableEurosInfo', '')
  }, [setFieldValue])

  return (
    <Form.Group>
      <Form.Label
        text='CUENTA EUROS'
        htmlFor='select-cuentaContableEuros'
        md={4}
        alignRightAt='md'
      />
      <Col md={8}>
        {iValue ? (
          <ClearInputGroup id='cuentaContableEuros' iValue={iValue} clickClear={clickClear} />
        ) : (
          <Select2CuentaContable id='select-cuentaContableEuros' onChange={onChange} />
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContableEurosFormGroup)
